import React, { Fragment, useRef, useState, useEffect } from 'react';
import { translate } from '../Services/translation';
import constants from '../constants';
const hasNameOrChildren = (link) => link.name || (link.links || []).length > 0;

let menuTopLinkIndex = 0;

const GetImageLinks = ({ links, clickedIndex, setClickedIndex }) => {
  if (links.length > 0 && links[0].imageUrl?.length) {
    return (
      <Fragment>
        <section className="row large-up-4 main-menu__images">
          {links.length > 0 &&
            links.map(
              (link, index) =>
                hasNameOrChildren(link) && (
                  <div
                    className="column"
                    key={`navimage${index}{menuTopLinkIndex}`}
                  >
                    <label
                      htmlFor={`main-menu__images-radio${index}${menuTopLinkIndex}`}
                      className={`${clickedIndex === index ? 'active' : ''}`}
                      onClick={() => {
                        setClickedIndex(index);
                      }}
                    >
                      <figure>
                        <a href={link.url}>
                          <img src={link.imageUrl} alt={link.extraInfo} />
                          <figcaption>{link.name}</figcaption>
                        </a>
                      </figure>
                    </label>
                  </div>
                )
            )}
        </section>
      </Fragment>
    );
  }
  return null;
};

const NavigationItem = ({
  links = [],
  contentLink = null,
  subLevel = 0,
  fullMenu,
}) => {
  const menuRef = useRef(null);
  const [mainMenuActive, setMainMenuActive] = useState(false);
  const [clickedIndex, setClickedIndex] = useState(false);

  const toggleMenu = (e, isTopIcon = false) => {
    e.preventDefault();
    const classList = menuRef?.current?.classList;
    if (classList) {
      if (isTopIcon) {
        e.target.classList.toggle('navbar__menu--show');
        const $bodyEl = document.querySelector('body');
        if ($bodyEl) {
          if ($bodyEl.classList.contains('navbar__mobile-menu--active')) {
            const $activeMenu = document.querySelectorAll(
              '.navbar__menu--show'
            );

            if ($activeMenu) {
              $activeMenu.forEach((menu) => {
                menu.classList.remove('navbar__menu--show');
              });
            }
            $bodyEl.classList.toggle('navbar__mobile-menu--active');
            setMainMenuActive(false);
            return;
          }
          $bodyEl.classList.toggle('navbar__mobile-menu--active');
        }
      }
      classList.toggle('navbar__menu--show');
    }
    setMainMenuActive(!mainMenuActive);
  };
  const additionClass =
    contentLink && contentLink.attributes
      ? contentLink.attributes.cssValue
      : null;
  const selectedClass =
    contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
  const hasChildrenClass = links.length > 0 ? 'has-children' : null;

  const getLowerLevelLinkCountClass = (amount) => {
    if (amount > 40) {
      return 'large';
    } else if (amount > 20) {
      return 'medium';
    }
    return 'small';
  };
  menuTopLinkIndex++;

  const checkClickedIndex = (index) => {
    if (index !== clickedIndex) {
      setClickedIndex(index);
    }
    // : null
  };

  if (!contentLink && links?.length < 1) {
    return null;
  }

  return (
    <Fragment>
      <div id="quickSearchNew"></div>
      {!contentLink ? (
        <a
          className="navbar__link--block navbar__icon--menu navbar__icon"
          onClick={(e) => toggleMenu(e, true)}
          rel="nofollow"
          href="#"
          title={translate('general.menu') || 'menu'}
        ></a>
      ) : (
        <Fragment>
          <a
            className={`navbar__link ${selectedClass} ${
              hasChildrenClass || ''
            } ${additionClass || ''}`}
            href={contentLink.url || '#'}
            dangerouslySetInnerHTML={{ __html: contentLink.name }}
          ></a>
          {links.length > 0 && subLevel <= 1 && (
            <i
              className="navbar__icon--caret-right navbar__icon navbar__icon--open"
              onClick={toggleMenu}
            ></i>
          )}
        </Fragment>
      )}

      {links.length > 0 && (
        <div
          className={`navbar__menu ${
            subLevel === 1 && links.length > 0 && links[0].imageUrl?.length
              ? 'navbar__menu-images'
              : ''
          }`}
          ref={menuRef}
        >
          <div className="navbar__menu-header">
            {contentLink && (
              <Fragment>
                <i
                  className="navbar__icon--caret-left navbar__icon"
                  onClick={toggleMenu}
                ></i>
                <span
                  className="navbar__title"
                  onClick={toggleMenu}
                  dangerouslySetInnerHTML={{
                    __html: contentLink.name,
                  }}
                ></span>
              </Fragment>
            )}
          </div>
          {subLevel === 1 && (
            <GetImageLinks
              links={links}
              setClickedIndex={setClickedIndex}
              clickedIndex={clickedIndex}
            />
          )}
          <ul
            className={`navbar__menu-links sub-level-${subLevel} sub-links-count-${
              links?.length || 0
            } ${
              subLevel === 2
                ? getLowerLevelLinkCountClass(links?.length || 0)
                : ''
            }`}
          >
            {links.length > 0 &&
              links.map(
                (link, index) =>
                  hasNameOrChildren(link) && (
                    <Fragment key={`navItem${index}`}>
                      <li className="navbar__item">
                        {subLevel <= 1 && (
                          <NavigationItem
                            links={link.links}
                            contentLink={link}
                            subLevel={subLevel + 1}
                          />
                        )}
                      </li>
                    </Fragment>
                  )
              )}
          </ul>
          {!contentLink && constants && constants.topLinkList && (
            <ul className="navbar__menu-links navbar__top-menu-links">
              {constants.topLinkList.map((link, index) => (
                <li className="navbar__item" key={`topItem${index}`}>
                  <a className="navbar__link" href={link.href}>
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default NavigationItem;
